import styled from "@emotion/styled";
import { Common } from "../../assets/styles/common";

export const ButtonText = styled.span`
color:${Common.colors.brown_light};
`